import { render, staticRenderFns } from "./ImageHomeworkCreator.vue?vue&type=template&id=2ea9c209&scoped=true"
import script from "./ImageHomeworkCreator.vue?vue&type=script&lang=js"
export * from "./ImageHomeworkCreator.vue?vue&type=script&lang=js"
import style0 from "./ImageHomeworkCreator.vue?vue&type=style&index=0&id=2ea9c209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9c209",
  null
  
)

export default component.exports